import { RefObject, useEffect, useRef } from 'react';

import { IChipsItem } from '../Chips/ChipsItem/ChipsItem.types';
import { usePreviousValue } from '../hooks/usePreviousValue/usePreviousValue';

interface IUseScrollToTheEndResult {
  chipsRef: RefObject<HTMLDivElement>;
}

export const useScrollToTheEnd = (chips: IChipsItem[]): IUseScrollToTheEndResult => {
  const prevChips = usePreviousValue(chips);
  const chipsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (prevChips && chips.length > prevChips.length) {
      const { childNodes } = chipsRef.current as HTMLDivElement;

      (childNodes.item(childNodes.length - 1) as HTMLElement).scrollIntoView({
        inline: 'end',
        behavior: 'auto',
      });
    }
  }, [chips.length, prevChips]);

  return {
    chipsRef,
  };
};
